import Alpine from 'alpinejs';

// Components
import parallax from './modules/parallax.js';
import swipers  from './modules/swiper.js';
import timeline  from './modules/timeline.js';
import accordion  from './modules/accordion.js';

Alpine.data('parallax', parallax);
window.Alpine = Alpine;
Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
    // Alpine.start();
    console.log('DOM fully loaded and parsed');
    // parallax();
    swipers();
    timeline();
});

let floatingImages = (floatingDiv) => {
    if  (window.innerWidth < 768) return;
    let h = floatingDiv.offsetHeight;
    if (h === 0) {
        const abs = floatingDiv.querySelector('.absolute');
        if (abs) h = abs.clientHeight;
    }

    if (!h) return;

    const prev = floatingDiv.previousElementSibling;
    const next = floatingDiv.nextElementSibling;

    if (prev) {
        const currentPB = parseFloat(getComputedStyle(prev).paddingBottom) || 0;
        const newPB = Math.min(currentPB + h * 0.3, 350);
        prev.style.paddingBottom = `${newPB}px`;
    }

    if (next) {
        const currentPT = parseFloat(getComputedStyle(next).paddingTop) || 0;
        const newPT = Math.min(currentPT + h * 0.7, 350);
        next.style.paddingTop = `${newPT}px`;
    }
};

window.addEventListener('load', function() {
    let floatingDivs = document.querySelectorAll('.floating');
    floatingDivs.forEach(floatingDiv => {
        floatingImages(floatingDiv);
    });

    let floatingTextBoxes = document.querySelectorAll('.floating-div');
    floatingTextBoxes.forEach(floatingTextBox => {
        floatingImages(floatingTextBox);
    });

    accordion();
});

const setBannerHeight = () => {
    const header = document.querySelector('header.header');
    const banner = document.querySelector('.main-banner');

    if (!header || !banner) return;

    let headerHeight = header.offsetHeight;
    headerHeight = headerHeight - 35;
    banner.style.height = `calc(100dvh - ${headerHeight}px)`;
};

window.addEventListener('load', setBannerHeight);
window.addEventListener('resize', setBannerHeight);